import React, {useEffect, useState} from 'react';
import Resolution from 'engine/Resolution.js';
import {WIDTH, LEFT_SPACE} from '../pianoroll/constants.js';
import Colors from 'components/Colors.js';
const colors = new Colors();

const baseResolution = new Resolution(32, false);

export const useGridStyle = ({
    selectedPianoRollSteps,
    stepData,
    isAlternateColor,
    xScale,
    resolution,
    position,
    stepNumber,
    height,
    duration,
    color,
    isGuideStep,
    track
}) => {
    let isSelectedStep = selectedPianoRollSteps !== undefined 
        && selectedPianoRollSteps.indexOf(stepData) > -1;
    let width = xScale * WIDTH * resolution.numSteps() / 16;
    let unquantizedOffset = position * WIDTH * xScale;
    let left = stepNumber * WIDTH * xScale + unquantizedOffset;

    let _duration = stepData ? stepData.duration : duration;
    let _stepNumber = baseResolution.transformStepAtResolution(stepNumber, resolution);
    if (!track) {
        track = {length: 32};
    }
    let ogDur = _duration;
    if (_stepNumber + _duration*2 > track.length ) {
        let diff = (_stepNumber+_duration*2) - track.length;
        _duration -= diff / 2;
    }

    let style = {
        left: left,
        height: height,
        lineHeight: height + 'px',
        fontSize: Math.min(16, height) + 'px',
        width: width * _duration,
        backgroundColor: isSelectedStep ? colors.brighten(color, 0.3) : color
    };

    if (isSelectedStep) {
        style.borderColor = color;
    } 

    let className = isAlternateColor ? "alternate " : "";
    className += isSelectedStep ? " selected " : "";

    if (isGuideStep) {
        className += " guide-step";
    }

    let slideStyle = {};
    if (!isGuideStep && stepData.slide) {
        slideStyle.borderLeftWidth = style.width - 2;
        slideStyle.borderBottomWidth = height * 0.8;
    }
    return {className, style, slideStyle};
};
